import { render } from "./RegisterComplete.vue?vue&type=template&id=5a75bcd8&scoped=true"
import script from "./RegisterComplete.vue?vue&type=script&lang=js"
export * from "./RegisterComplete.vue?vue&type=script&lang=js"

import "./RegisterComplete.vue?vue&type=style&index=0&id=5a75bcd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a75bcd8"]])

export default __exports__